import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { class: "container-fluid p-8 border border-l-8 border-[#0b295b] shadow-xl rounded-lg bg-gray-100" }
const _hoisted_3 = { class: "flex flex-col justify-center md:flex-row md:space-x-2 space-y-2 md:space-y-0" }

import DropDown from "@/components/DropDown.vue";
import TextInput from "@/components/TextInput.vue";
import { terrorStates, idStates } from "./commons";
import {
  TruckerIdentificationTODocumentStatusEnum,
  TruckerIdentificationTOTerrorStatusEnum,
} from "@/services/api-client/client";

import { ref, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSearchBar',
  emits: ["submit"],
  setup(__props, { emit: __emit }) {

const userId = ref<string | undefined>(undefined);

const terrorState = ref<TruckerIdentificationTOTerrorStatusEnum | undefined>(
  undefined
);

const warningState = ref<TruckerIdentificationTODocumentStatusEnum | undefined>(
  undefined
);

const emit = __emit;

const clearData = () => {
  userId.value = undefined;
  warningState.value = undefined;
  terrorState.value = undefined;
  emit("submit", payload.value);
};

const payload = computed(() => {
  return {
    userId: userId.value,
    warningState: warningState.value,
    terrorState: terrorState.value,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TextInput, {
          modelValue: userId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userId).value = $event)),
          placeholder: "User Id",
          wide: true
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", null, [
          _createVNode(DropDown, {
            "selected-value": terrorState.value,
            title: "Terror state",
            onSelect: _cache[1] || (_cache[1] = (t)=> terrorState.value = t as TruckerIdentificationTOTerrorStatusEnum),
            entries: _unref(terrorStates)
          }, null, 8, ["selected-value", "entries"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(DropDown, {
            "selected-value": warningState.value,
            onSelect: _cache[2] || (_cache[2] = (t)=> warningState.value = t as TruckerIdentificationTODocumentStatusEnum),
            title: "Identification State",
            entries: _unref(idStates)
          }, null, 8, ["selected-value", "entries"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = () => _ctx.$emit('submit', payload.value)),
            class: "btn btn-info w-32"
          }, " Search ")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = () => clearData()),
            class: "btn btn-warning w-32"
          }, " Clear ")
        ])
      ])
    ])
  ]))
}
}

})